import React from "react";
export const ViewportContext = React.createContext({
    viewport: null,
});
